export function SvgCloseCalendar() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 5L15 15" stroke="#35434E" strokeLinecap="round" />
      <path d="M15 5L5 15" stroke="#35434E" strokeLinecap="round" />
    </svg>
  );
}
